export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15082.bca7198a.jpg";